
export class ConnectionState {
  isInternetConnected = true;
  isNatsConnected = false;
}
